// extracted by mini-css-extract-plugin
export var active = "style-module--active--51085";
export var caption = "style-module--caption--04378";
export var dot = "style-module--dot--057d1";
export var enabled = "style-module--enabled--ad1f1";
export var fadeBlock = "style-module--fade-block--3039f";
export var nav = "style-module--nav--6f0e4";
export var option = "style-module--option--5b498";
export var select = "style-module--select--40cc2";
export var selectLabel = "style-module--select-label--d4ea5";